<div class="treo-drawer-content">
    <ng-content></ng-content>
</div>
